<template>
  <el-dialog
      :visible.sync="visible"
      title="出入库明细"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
      @close="closeHandler"
      :append-to-body="true"
  >
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
    >
      <el-form-item label="合同编号：">
        <el-input
            v-model="dataForm.agreementCode"
            placeholder=""
            :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="仓库：">
        <storages v-model="dataForm.storageId" :disabled="true" size="mini"></storages>
      </el-form-item>
      <el-form-item label="出入库日期：">
        <el-date-picker
            v-model="dateArr"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="doExport()">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%"
        @selection-change="dataListSelectionChangeHandle"
    >
      <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
      ></el-table-column>
      <el-table-column
          label="行号"
          type="index"
          header-align="center"
          align="center"
          width="50"
      ></el-table-column>
      <el-table-column label="图片" header-align="center" align="center" width="140">
        <template v-slot:default="scope">
          <el-image style="width: 100px;height:100px;" :preview-src-list="scope.row.imgs" v-if="scope.row.previewImg"
                    :src="scope.row.previewImg" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="产品/原料" header-align="center" width="300">
        <template slot-scope="scope">
          <div v-if="scope.row.productCode">
            品番号：{{ scope.row.productCode }}
          </div>
          <div>品名：{{ scope.row.productName }}</div>
          <div class="flex">
            <div style="" v-if="scope.row.color">
              颜色：{{ scope.row.color }}
            </div>
            <div style="margin-left:20px;" v-if="scope.row.size">
              规格：{{ scope.row.size }}
            </div>
          </div>
          <div class="flex">
            <div v-if="scope.row.attr1">幅宽：{{ scope.row.attr1 }}</div>
            <div v-if="scope.row.attr2" style="margin-left:20px;">
              克重：{{ scope.row.attr2 }}
            </div>
          </div>
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--          prop="agreementCode"-->
      <!--          label="合同编号"-->
      <!--          header-align="center"-->
      <!--          align="center"-->
      <!--      ></el-table-column>-->
      <el-table-column
          label="出入库类型"
          header-align="center"
          align="center"
          width="100"
      >
        <template slot-scope="scope">
          <div style="color:#67C23A;" v-if="scope.row.type === 1">
            入库
          </div>
          <div style="color:#F56C6C;" v-else-if="scope.row.type === -1">
            出库
          </div>
        </template>
      </el-table-column>
      <el-table-column
          label="数量"
          header-align="center"
          align="center"
          width="100"
      >
        <template slot-scope="scope">
          <div style="color:#67C23A;" v-if="scope.row.type === 1">
            {{ scope.row.count }}
          </div>
          <div style="color:#F56C6C;" v-else-if="scope.row.type === -1">
            {{ scope.row.count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="storageName"
          label="仓库"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="operateTime"
          label="出入库日期"
          header-align="center"
          align="center"
          :formatter="timeFormatter"
          width="110"
      >
      </el-table-column>
      <el-table-column
          prop="reason"
          label="原因"
          header-align="center"
          align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.reason || scope.row.remark }}
        </template>
      </el-table-column>
      <el-table-column
          prop="creatorName"
          label="操作人"
          header-align="center"
          width="120"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="createDate"
          label="操作时间"
          header-align="center"
          align="center"
          width="160"
      >
      </el-table-column>
<!--      <el-table-column label="状态" header-align="center" align="center" width="80">-->
<!--        <template slot-scope="scope">-->
<!--          <el-tag :type="scope.row.status === 10 ? 'primary' : 'danger'">{{-->
<!--              $dictFormat('purchase_log_status', scope.row.status)-->
<!--            }}-->
<!--          </el-tag>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div class="page-box">
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
    <UpdateDialog ref="updateDialog"></UpdateDialog>
  </el-dialog>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import moment from 'moment'
import qs from 'qs'
import Cookies from 'js-cookie'
import UpdateDialog from '@/views/modules/store/store-log/update'

export default {
  mixins: [mixinViewModule],
  components: { UpdateDialog },
  data () {
    return {
      dateArr: [],
      hasCountB: window.SITE_CONFIG['hasCountB'],
      mixinViewModuleOptions: {
        getDataListURL: '/trade/factorystorelog/page',
        exportURL: '/trade/factorystorelog/export',
        getDataListIsPage: true,
        activatedIsNeed: false,
      },
      dataForm: {
        storageId: '',
        agreementCode: '',
        agreementId: '',
        productType: '',
        storeType: '',
        productId: '',
        ids: [],
        beginDate: '',
        endDate: ''
      },
      currentId: '',
      visible: false
    }
  },
  watch: {
    dateArr (newVal) {
      if (newVal && newVal.length === 2) {
        this.dataForm.beginDate = newVal[0]
        this.dataForm.endDate = newVal[1]
      } else {
        this.dataForm.beginDate = ''
        this.dataForm.endDate = ''
      }
      this.currentId = ''
      this.reload()
    },
  },
  methods: {
    //显示修改
    showUpdateDialog (row) {
      this.$refs.updateDialog.storeType = row.type
      this.$refs.updateDialog.id = row.id
      this.$refs.updateDialog.init()
    },
    closeHandler () {
      this.$emit('close')
    },
    changeCountB (row) {
      this.$prompt('请输入B品数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,3})?$)/,
        inputErrorMessage: '请输入正确的数量',
      }).then(({ value }) => {
        this.$http
            .post(`/trade/factorystorelog/change/count`, { id: row.id, countB: value })
            .then(({ data: res }) => {
              if (res.code != 0) {
                return this.$message.error(res.msg)
              }
              this.$message.success('保存成功')
              this.reload()
            })
      })
    },
    beforeTableBinding (dataList) {
      if (!dataList) {
        return
      }
      dataList.forEach(item => {
        if (item.imgs) {
          item.imgs = JSON.parse(item.imgs)
          if (item.imgs && item.imgs.length > 0) {
            item.previewImg = item.imgs[0]
          } else {
            item.previewImg = ''
          }
        }
      })
    },
    init () {
      this.reload()
      this.visible = true
    },
    doExport () {
      if (this.dataListSelections.length === 0) {
        return this.$message.error('请选择要导出的记录')
      }
      this.dataForm.ids = this.dataListSelections
          .map((item) => item.id)
          .join(',')
      console.log('this.dataForm.ids', this.dataForm.ids)
      var params = qs.stringify({
        token: Cookies.get('token'),
        ...this.dataForm,
      })
      window.location.href = `${window.SITE_CONFIG['apiURL']}${this.mixinViewModuleOptions.exportURL}?${params}`
    },
    timeFormatter (row, column, cellValue, index) {
      if (!cellValue) {
        return ''
      }
      return moment(cellValue).format('yyyy-MM-DD')
    },
    // doRefund (row) {
    //   this.$confirm('是否进行退货操作?', '操作提示').then(() => {
    //     this.$http
    //         .post(`/trade/factorystorelog/refund`, { id: row.id })
    //         .then(({ data: res }) => {
    //           if (res.code !== 0) {
    //             return this.$message.error(res.msg)
    //           }
    //           this.$message.success(`操作成功`)
    //           this.getDataList()
    //         })
    //         .catch((e) => {
    //           this.$message.error(e)
    //         })
    //   })
    // },
  },
}
</script>
